export default "__VITE_ASSET__CoIKt5eP__"